import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const date = (dt?: string | Date) =>
  dt ? dayjs(dt).tz("America/Sao_Paulo") : dayjs().tz("America/Sao_Paulo");
